const MB = 1000 * 1000;

export default {
  MAX_FILE_SIZE: 3000000,
  PLAIN_WOOD_FILE: 1000000,
  MAXIMUM_FILE_SIZES: {
    default: 3 * MB, // 3MB
    small: 1 * MB, // 1MB
    medium: 3 * MB, // 3MB
    large: 5 * MB, // 5MB
    xlarge: 10 * MB, // 10MB
    xxlarge: 15 * MB, // 15MB
    max: 5 * 1000 * MB, // 5GB = S3 にアップロード可能な最大サイズ
  },
  MB,
};
